import {Box, Button } from '@material-ui/core'
import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'

import { resetSuccess } from 'redux/actions/tanks/tanksAction'
import AddIcon from "@material-ui/icons/Add";

import { getTanks } from 'redux/actions/tanks/tanksAction'
import { columns } from './columns'
import Snackbars from "components/Snackbar/Snackbar.js";
import { resetTankSelected } from 'redux/actions/tanks/tanksAction'
import { addTankMode } from 'redux/actions/tanks/tanksAction'
import { resetError } from 'redux/actions/tanks/tanksAction';
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchMenuConfigSync from 'components/SearchMenuConfigSync/SearchMenuConfigSync';
import { useColorTheme } from 'hooks/useColorTheme';
import { convertToMapById } from 'helpers/convertToMap';
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormTankEdit } from './FormTankEdit'

const blue = '#0055aa'
export const TanksPage = () => {
  const colorBg = useSelector((state) => state.config.colorBg);
  const { color, colorRGB } = useColorTheme(colorBg);
  const { companies } = useSelector(state => state.companies)
  const { units } = useSelector(state => state.unitsReducer)
  const {  tanks, loading, dataSuccess, messageSuccess, addMode, error, errorMessage } = useSelector(state => state.tanks)
  const { isOpen, handleIsOpen } = useOpenComponent()
  const [company, setCompany] = useState()
  const [mapCompanies, setMapCompanies] = useState([])
  const [stations, setStations] = useState()
  const [selectStation, setSelectStation] = useState([])
  const [mapData, setMapData] = useState([])
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(resetTankSelected())
    handleIsOpen()
  }
  
  const handleOpenAdd = () => {
    dispatch(addTankMode())
    handleIsOpen()
  }
  const handleRefreshTanksData = () => {
    dispatch(getTanks())
  }

  useEffect(() => {
    setMapCompanies(convertToMapById(companies))
  }, [companies])
  
  useEffect(() => {
    if(company) {
      setSelectStation([])
      setStations( companies[company]?.stations )
    }
  }, [company, companies])

  useEffect(() => {
    if(selectStation.length === 0){
      setMapData(
        stations?.map(val => {
          return Object.keys(tanks)?.map(id => tanks[id]).filter(tank => units[tank?.id_unit]?.idStation === val.id ).map(tank2 => {
            return {
              ...tank2,
              numberLabel: units[tank2.id_unit]?.number,
              modal: handleIsOpen ,
            }
          })
        }).flat()
      )
    }
    // eslint-disable-next-line
  }, [stations, selectStation, tanks])

  const handleCleanError = () => {
    dispatch(resetError())
  }

  const handleSelectCompany = (e) => {
    setCompany(e.target.value)
  }

  const handleSelectStation = (value = []) => {
    setSelectStation( value ? value : [])
  }

  useEffect(() => {
    if(selectStation.length > 0) {      
      setMapData(
        selectStation?.map(val => {
          return Object.keys(tanks)?.map(id => tanks[id]).filter(tank => units[tank?.id_unit]?.idStation === val.id).map(tank2 => {
            return {
              ...tank2,
              numberLabel: units[tank2.id_unit]?.number,
              modal: handleIsOpen ,
            }
          })
        }).flat()
      )
    }
    // eslint-disable-next-line
  }, [tanks, selectStation])


  useEffect(() => {
    setMapData(
      Object.keys(tanks)?.map(id => tanks[id]).map(tank2 => {
        return {
          ...tank2,
          numberLabel: units[tank2.id_unit]?.number,
          modal: handleIsOpen ,
        }
      }).flat()
    )
    // eslint-disable-next-line
  }, [units, tanks])

  return (
    <React.Fragment>
      <SearchMenuConfigSync
        color={color}
        colorRGB={colorRGB}
        companies={mapCompanies}
        stations={ stations }
        companySelect={company}
        stationSelect={selectStation}
        blockUnitType={false}
        onCompanySelect={handleSelectCompany}
        onStationSelect={handleSelectStation}
        multiSelect
      />

              <Box style={{display: 'flex', flexGrow: 1, justifyContent: 'flex-end'}}>

                <Button
                  style={{ borderRadius: 50, backgroundColor:  blue, width: 55, height: 65,  marginRight: 15}}
                  // color={color}
                  onClick={handleRefreshTanksData}
                  >
                  <RefreshIcon style={{color: 'white',}}/>
                </Button>
                <Button
                  style={{ borderRadius: 50, backgroundColor:  blue, width: 55, height: 65}}
                  // color={color}
                  onClick={handleOpenAdd}
                  >
                  <AddIcon style={{color: 'white'}}/>
                </Button>
              </Box>
      <CardTable
        data={mapData}
        columns={columns}
        loading={ loading }
        previousText="Anterior"
        nextText="Siguiente"
        noDataText="Sin datos"
        pageText="Pagina"
        ofText="de"
        rowsText="Tanques"
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={ addMode ? 'Agregar nuevo tanque' : 'Editar tanque' }
      >
        {
          addMode
          ? <FormTankEdit handleClose={handleClose} add company={company}/>
          : <FormTankEdit handleClose={handleClose}/>
        }
      </ModalV2>

      <Snackbars
        place="tr"
        color="success"
        message={messageSuccess}
        open={dataSuccess}
        closeNotification={() => dispatch(resetSuccess())}
        close
      /> 
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={handleCleanError}
        close
      /> 
    </React.Fragment>
  )
}
